"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var CardActionComponent = (function () {
    function CardActionComponent() {
        this.actionClicked = new core_1.EventEmitter();
    }
    CardActionComponent.prototype.onClicked = function (event) {
        event.preventDefault();
        this.actionClicked.emit(null);
    };
    return CardActionComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CardActionComponent.prototype, "color", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CardActionComponent.prototype, "icon", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], CardActionComponent.prototype, "actionClicked", void 0);
CardActionComponent = __decorate([
    core_1.Component({
        selector: 'card-action',
        template: "\n      <button class=\"btn btn-float waves-effect bgm-{{color}}\" (click)=\"onClicked($event)\"><i class=\"zmdi zmdi-{{icon}}\"></i></button>\n    ",
    }),
    __metadata("design:paramtypes", [])
], CardActionComponent);
exports.CardActionComponent = CardActionComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/card/card-action.component.js
// module id = 107
// module chunks = 0